export const MarketplaceItemConfig = {
  priceCentsMin: 1,
  priceCentsMax: 4294967295, // MySQL unsigned integer

  quantityMax: 9999,
  quantityMin: 1,

  nameMaxLength: 255,
  nameMinLength: 1,

  descriptionMaxLength: 4000,
  descriptionMinLength: 1,
};
